import styled from '@emotion/styled';
import { Loader } from 'src/domains/layouts/webview/components/loader/Loader';

export const LoaderWrapper = styled(Loader, { label: 'LoaderWrapper' })`
    justify-content: center;
`;
